import React, { Component } from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import {   Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';

import { toggleThinkToolPopup, toggleUserDashboard } from '../../redux/reducers/view';
import { withRouter } from 'react-router-dom';

import { learnerVersionsRequest, resetLearnerVersion, resetPathToSaveVersion } from '../../redux/reducers/savedVersions';
import Popup from '../Popup';

import { commonStyles } from '../../styles/styles';
import questionsImage from '../../assets/questions-circular.svg';

import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import { getVersions, getVersionsStatus } from '../../redux/selectors';
import { xapiRequest } from '../../redux/reducers/xapi';
import { selectUserVersion } from '../../redux/reducers/userProgramsFull';
import { contentItemRequest } from '../../redux/reducers/contentList';



class ThinkToolPopup extends Component {
  state = {
    modal: true
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
   // this.props.resetPathToSaveVersion();
    this.props.toggleThinkToolPopup(false)
  }
 
  render() {
  return this.props.savedVersions.isFetched === true ? (
    <MDBContainer >
        <MDBModal isOpen={this.props.view.thinkToolPopup} toggle={this.toggle}  centered  >
          <MDBModalHeader style={{textAlign:'left', margin: 5}} className="default-color text-white" toggle={this.toggle}><div style={{color: '#ffffff !important'}}>Open Thinktool</div> </MDBModalHeader>
          <MDBModalBody>
          <div className="mb-2 mt-2">
            How do you want to access your thinktool?
          </div>
          </MDBModalBody>
          <MDBModalFooter>
            
          {this.props.versionStatus && this.props.versionStatus.length==0 && <Link
                to={`${this.props.selectedContentId}`}
                onClick={this.props.hidePopup}
              >
               <MDBBtn 
                    size="md"
                    variant="contained" 
                    className='mt-5 btn-dark-green'
                    action
                    onClick={this.props.onStartAgainButtonClick}>
                  Start Again
                </MDBBtn>
            </Link>}
            {this.props.versions && (
              <MDBBtn 
                  size="md"
                  variant="contained" 
                  className='mt-5 danger-color-dark'
                  onClick={this.props.onVersionsButtonClick}
                  action>
                  My Versions
              </MDBBtn>
            )}
         
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
  ) : null;
            }
};

const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
  currentLink: {
    width: 'auto',
  },
  button: {
    width: 100,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: 30,
  },
  header: {
    textAlign: 'center',
  },
});

const mapStateToProps = state => ({
  programsFull: state.userProgramsFullReducer,
  savedVersions: state.savedVersionsReducer,
  versions: getVersions(state),
  versionStatus: getVersionsStatus(state),
  view: state.viewReducer
});

const mapDispatchToProps = dispatch => ({
  toggleThinkToolPopup: value => dispatch(toggleThinkToolPopup(value)),
  toggleUserDashboard: value => dispatch(toggleUserDashboard(value)),
  learnerVersionsRequest: () => dispatch(learnerVersionsRequest()),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
  selectUserVersion: id => dispatch(selectUserVersion(id)),
  resetPathToSaveVersion: () => dispatch(resetPathToSaveVersion()),
  getContentItem: () => dispatch(contentItemRequest()),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    onVersionsButtonClick: props => () => {
      const { toggleUserDashboard, toggleThinkToolPopup } = props;
      toggleThinkToolPopup(false);
      
      props.xapiRequest({ xapiType: `OpenedVersions`});
      props.history.push('/versions/'+props.programsFull.selectedProgramId+'/'+props.programsFull.selectedModuleId+'/'+props.programsFull.selectedContentId)
    },

    onStartAgainButtonClick: props => () => {
      const { toggleUserDashboard, toggleThinkToolPopup } = props;
      toggleThinkToolPopup(false);
      props.xapiRequest({ xapiType: `Opened`});
      props.selectUserVersion(null);
      props.resetPathToSaveVersion();
      props.history.push('/tools/'+props.programsFull.selectedProgramId+'/'+props.programsFull.selectedContentId)
    },

  //   <Link
  //   to={`${
  //     location.pathname
  //   }/${selectedProgramId}/${selectedModuleId}/${selectedContentId}`}
  //   className={`${classes.link} ${classes.currentLink}`}
  //   onClick={hidePopup}
  // >
    hidePopup: props => () => {
      props.toggleThinkToolPopup(false);
    },
  }),
  lifecycle({
    componentWillMount(){
      
    },
    componentWillReceiveProps() {
      
      if(this.props.view.thinkToolPopup && this.props.savedVersions.isFetched==false && this.props.savedVersions.fetching==false){
        this.props.getContentItem();
        this.props.learnerVersionsRequest();
      }
    },
  }),
  withStyles(styles),
)(ThinkToolPopup);

ThinkToolPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  programsFull: PropTypes.instanceOf(Object),
  toggleThinkToolPopup: PropTypes.func,
  location: PropTypes.instanceOf(Object),
  savedVersions: PropTypes.instanceOf(Object),
  onVersionsButtonClick: PropTypes.func,
  hidePopup: PropTypes.func,
};
